import {Box, Grid, Stack, Typography} from '@mui/material';
import styles from '../../../Pages/ChatBotComponent/ChatBotComponent.module.css';
import React, {useEffect, useState} from 'react';
import Card from '../Card/Card';
import style from './DashboardListInChat.module.css';
import {
  getDashboardLists,
  getPBIDashboards,
} from '../../../Services/chat-bot-service';
import {Spinner} from 'react-bootstrap';
export interface DashboardListInChatProps {
  handleViewSummary?: (projName: string) => any;
  handleDashboard?: (projName: string, url: string) => any;
  onPage: any;
  loading?: any;
  loadingTitle: any;
}

const DashboardListInChat = ({
  handleViewSummary,
  handleDashboard,
  onPage,
  loading,
  loadingTitle,
}: DashboardListInChatProps) => {
  const [pbiList, setpbiList] = useState<any>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const pepappdwdroles = sessionStorage.getItem('pepappdwdroles');
  const getPBIDashboardsList = async () => {
    setLoading(true);
    // const response = await getPBIDashboards();
    const response = await getDashboardLists();
    // console.log("response::;", response)
    setpbiList(response);
    setLoading(false);
  };
  useEffect(() => {
    getPBIDashboardsList();
  }, []);
  const showSummary = (projName: string) => {
    handleViewSummary && handleViewSummary(projName);
  };

  const handleDashboardClick = (projName: string, url: string) => {
    handleDashboard && handleDashboard(projName, url);
  };

  return (
    <>
      {isLoading ? (
        <div className={'loaderWrapperRightPanel'}>
          <Spinner
            animation='border'
            variant='primary'
          >
            <span className='visually-hidden'></span>
          </Spinner>
        </div>
      ) : (
        <Stack
          direction='column'
          spacing={4}
          useFlexGap
          sx={{
            // alignItems: 'center',
            alignItems: { xs: 'center', sm: 'stretch' },
            maxHeight: {xs: '80vh'},
            overflowY: 'auto',
          }}
        >
          <Box className={styles.intro}>
            <Typography
              variant='h4'
              component='div'
              gutterBottom
            >
              Getting started
            </Typography>
            <Typography
              variant='body1'
              color='text.secondary'
            >
              Select one of the options below to quickly begin
            </Typography>
          </Box>
          <Stack
            direction='row'
            spacing={{xs: 2, sm: 4}}
            useFlexGap
            className={style.cardsRow}
            sx={{
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            {pbiList &&
              pbiList.map((page: any, pageIndex: number) => {
                return (
                  pageIndex < 6 &&
                  page.is_active && (
                    <Card
                      data={page}
                      handleSummary={() => showSummary(page.title)}
                      handleDashboard={() =>
                        handleDashboardClick(page.title, page.embed_url)
                      }
                      onPage={onPage}
                      hidden={
                        page.title === 'UAE MT' &&
                        !pepappdwdroles?.includes('KAS MT')
                      }
                      loading={loading}
                      loadingTitle={loadingTitle}
                    />
                  )
                );
              })}
          </Stack>
          <div
            className={style.newChatText}
            style={{display: 'flex', justifyContent: 'center'}}
          >
            Click "View Summary" to access key insights and start a conversation
          </div>
        </Stack>
      )}
      {/* <Grid container spacing={1}>
      <Grid container item spacing={3}>
        <FormRow />
      </Grid>
      <Grid container item spacing={3}>
        <FormRow />
      </Grid>
    </Grid> */}
    </>
  );
};
export default DashboardListInChat;
